// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"04141b1f","343":"27c8e398","393":"e3333b08","488":"0872208f"}[chunkId] + ".chunk.js";
};